import { render, staticRenderFns } from "./Anm22PayCard.vue?vue&type=template&id=a556b592&scoped=true&"
import script from "./Anm22PayCard.vue?vue&type=script&lang=js&"
export * from "./Anm22PayCard.vue?vue&type=script&lang=js&"
import style0 from "./Anm22PayCard.vue?vue&type=style&index=0&id=a556b592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a556b592",
  null
  
)

export default component.exports